import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Container from "@mui/material/Container";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: "auto",
        color: "primary",
      }}
    >
      <Container maxWidth="lg">
        <Typography variant="body2" color="text.secondary" align="center">
          {"© "}
          {new Date().getFullYear()}{" "}
          <Link
            color="inherit"
            href="https://github.com/pravi-x"
            target="_blank"
            rel="noopener noreferrer"
          >
            pravi-x
          </Link>{" "}
          {t("All rights reserved.")}
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
